// React
import { HTMLProps } from "react"

// UI
import { cn } from "@/lib/utils"
import {
	NavLink as ReactRouterLink,
	NavLinkProps,
	NavLinkRenderProps,
} from "@/lib/router"

export const className = "focus:underline"

export const Anchor = ({
	className: classNameFromProps,
	children,
	...rest
}: HTMLProps<HTMLAnchorElement>) => {
	return (
		<a className={cn(classNameFromProps, className)} {...rest}>
			{children}
		</a>
	)
}

export const Link = ({
	className: classNameFromProps,
	href,
	badgeNumber,
	children,
	...rest
}: Omit<NavLinkProps, "to"> & {
	href: string
	badgeNumber?: number | null
}) => {
	return (
		<ReactRouterLink
			className={
				// confusing, but, we want to generate the class name here in this
				// component. and also pass in our classNames for all links.
				typeof classNameFromProps === "function"
					? (props: NavLinkRenderProps) =>
							cn(className, classNameFromProps(props))
					: cn(className, classNameFromProps)
			}
			to={href}
			{...rest}
		>
			<>
				{children}
				{badgeNumber ? (
					<span
						className={`ml-1 flex size-4 items-center justify-center rounded-full bg-red-600 text-white ${
							badgeNumber >= 10 ? "text-[0.625rem]" : "text-xs"
						}`}
					>
						{badgeNumber}
					</span>
				) : null}
			</>
		</ReactRouterLink>
	)
}
